/* eslint-disable no-underscore-dangle */
import PouchDB from 'pouchdb';
import { get } from '../utils/api';
import { upsert } from './common';
import endpoints from '../endpoints';

const PRODUCT_DELIVERY_PERIOD = 'XXSProductDeliveryPeriod';

class ProductDeliveryPeriodStore {
  constructor(name) {
    this.db = new PouchDB(name);
  }

  save = (response, onSuccess) => {
    upsert(this.db, PRODUCT_DELIVERY_PERIOD, response.data, onSuccess);
  };

  fetchAndSave = (onSuccess) => get(endpoints.deliveryPeriodAssignments.get).then((response) => this.save(response, onSuccess));

  load = (callback) => {
    this.db
      .get(PRODUCT_DELIVERY_PERIOD)
      .then((doc) => {
        callback(doc);
      })
      .then(() => {})
      .catch(() => {
        callback();
      });
  };
}

export default ProductDeliveryPeriodStore;
